import React from 'react';
import PropTypes from 'prop-types';
import { StyledHeadline } from './style';

const Headline = ({ className, children }) => (
  <StyledHeadline className={className}>{children}</StyledHeadline>
);

Headline.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

Headline.defaultProps = {};

export default Headline;
